import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const selector = '.home'

export default (
    el = null
) => {
    if (!el)
        return

    const heroItems = Array.from(el
        .querySelectorAll('.hero-home-item'))

    const sections = el
        .querySelectorAll('.acf-innerblocks-container section')

    if (!heroItems || !sections)
        return

    console.groupCollapsed('[Homepage] Animations')

    const gsapMm = gsap.matchMedia()

    // Full Bleed Asset
    const fbaItems = Array.from(sections).filter(item =>
        item.classList.contains('fba'))

    // Small Asset
    const saItems = Array.from(sections).filter(item =>
        item.classList.contains('small-asset'))

    // Large Text
    const ltItems = Array.from(sections).filter(item =>
        item.classList.contains('large-text'))

    if (fbaItems) {
        const fabLength = fbaItems.length
        const fbaItem = fbaItems[0]
        const fbaItemCover = fbaItem.querySelector('.fba-cover')

        const fbaLastItem = fabLength > 1
            ? fbaItems[(fabLength - 1)]
            : null

        const fbaLastItemCover = fbaLastItem
            ? fbaLastItem.querySelector('.fba-cover')
            : null

        gsap.set(fbaItem,
            { backgroundColor: 'var(--sgf-primary)' })

        gsapMm.add('(min-width: 1100px)', () => {
            gsap.set(fbaItemCover,
                { opacity: 0 })

            gsap.to(fbaItemCover, {
                opacity: 1,
                scrollTrigger: {
                    start: 'top center',
                    end: '40% center',
                    trigger: fbaItem,
                    scrub: true,
                    invalidateOnRefresh: true
                }
            })

            if (fbaLastItem)
                gsap.to(fbaLastItem, {
                    scrollTrigger: {
                        start: 'top top',
                        trigger: fbaLastItem,
                        scrub: true,
                        pin: fbaLastItemCover,
                        invalidateOnRefresh: true
                    }
                })
        })
    }

    if (saItems) {
        const saUpdateHeight = new CustomEvent('loadMoreEvent', {
            detail: {
                message: 'The page is updated with more items'
            },
            bubbles: true,
            cancelable: true
        })

        gsapMm.add('(min-width: 1100px)', () => {
            const windowWidth = window.innerWidth

            gsap.set('.small-asset-media', {
                opacity: 0,
                y: '40px'
            })

            saItems.forEach(item => {
                const media = item
                    .querySelector('.small-asset-media')

                const timeline = gsap.timeline({
                    scrollTrigger: {
                        start: 'top top',
                        end: `bottom ${
                            windowWidth >= 1300
                                ? 'center'
                                : 'top'}`,
                        trigger: item,
                        scrub: true,
                        smooth: true,
                        pin: media,
                        pinSpacing: true,
                        invalidateOnRefresh: true,
                        onLeave: () => {
                            item.dispatchEvent(saUpdateHeight)
                        }
                    }
                })

                timeline.to(media,
                    { opacity: 1 })
            })
        })
    }

    if (ltItems)
        gsapMm.add('(min-width: 1100px)', () => {
            gsap.set('.large-text-wrapper',
                { filter: 'blur(10px)' })

            ltItems.forEach(item => {
                const text = item
                    .querySelector('.large-text-wrapper')

                gsap.to(text, {
                    filter: 'blur(0px)',
                    scrollTrigger: {
                        start: 'top center',
                        end: '40% center',
                        trigger: item,
                        scrub: true,
                        invalidateOnRefresh: true
                    }
                })
            })
        })

    if (heroItems) {
        const heroItemsTitles = heroItems.map(item =>
            item.querySelector('.hero-home-item-title'))

        gsapMm.add('(min-width: 1100px)', () => {
            const windowWidth = window.innerWidth

            gsap.set([heroItemsTitles[1], heroItemsTitles[2]],
                { x: 150 })

            gsap.set(heroItems, {
                '--sgf-hero-home-width': '0%',
                pointerEvents: 'none',
                transition: 'none'
            })

            gsap.set(heroItems[0], {
                '--sgf-hero-home-width': '100%',
                flexShrink: 0
            })

            gsap.set(heroItems[2], {
                minWidth: '0',
                paddingRight: 0
            })

            const timeline = gsap.timeline({
                delay: 0.5,
                smooth: true,
                invalidateOnRefresh: true,
                onComplete: () => {
                    gsap.set(heroItems, {
                        clearProps: true
                    })
                },
                defaults: {
                    ease: 'slow'
                }
            })

            timeline.to(heroItems[0], {
                '--sgf-hero-home-width': '80%',
                duration: 1
            })

            timeline.to(heroItems[1], {
                '--sgf-hero-home-width': '20%',
                duration: 1,
                flexShrink: 0
            }, '<=')

            timeline.to(heroItemsTitles[1], {
                x: 0,
                duration: 1
            }, '<=')

            timeline.to(heroItems[0], {
                '--sgf-hero-home-width': '68%',
                duration: 0.5
            }, '+=0.5')

            timeline.to(heroItems[2], {
                '--sgf-hero-home-width': '12%',
                duration: 1,
                paddingRight: windowWidth >= 1300
                    ? '2.5em'
                    : '1.875em'
            }, '<=')

            timeline.to(heroItemsTitles[2], {
                x: 0,
                duration: 1
            }, '<=')

            window.addEventListener('resize', () => {
                gsap.set([heroItemsTitles], {
                    clearProps: true
                })
            })
        })
    }

    // Log instance
    console.log(el)

    console.groupEnd()

    return el
}
